export default __webpack_public_path__ + "static/VehicleReservation-855c957eb178ded3bcbe47d8af8db0ae.jpg";